import Vue from 'vue'

/**
 *  数値の桁を丸める
 * @param value 数値
 * @param decimal 小数点以下の桁数
 */
Vue.filter('fixDecimal', function (value: number | string | null | undefined, decimal: number = 1) {
  if (value === null || value === undefined || value === '') return ''

  const numberValue = typeof value === 'string' ? parseFloat(value) : value

  // 数値に変換できない場合は元の値を表示する（既にハイフン等が設定されている場合はそのまま表示する）
  if (Number.isNaN(numberValue)) return typeof value === 'string' ? value : ''

  // EL_2ND-2669: 平均点・偏差値が0の場合は、表示対象校以外で値が集計されていないことを意味するため
  // 「0.0」ではなくハイフンを表示する（このフィルターは平均点・偏差値の表示にのみ使用している）
  if (numberValue === 0) return '-'

  return numberValue.toFixed(decimal)
})
